import { render, staticRenderFns } from "./RsaPazienteAttivitaObiettiviComponent.vue?vue&type=template&id=77d6b884"
import script from "./RsaPazienteAttivitaObiettiviComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteAttivitaObiettiviComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports